/* The step-by-step clip: silent, looping, and not fetched at all until it is
   nearly on screen. Same deal as the video wall, minus the sound toggle — this
   one has no audio track to turn on. */
(function () {
  if (customElements.get('pdp-steps-video')) return;

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class StepsVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.pdp-steps__vid');
      if (!this.video) return;
      this.video.muted = true;

      // Autoplay is decoration here, so a visitor who has asked for less motion
      // gets the file and the browser's own controls instead of movement.
      if (REDUCED.matches) {
        this.load();
        this.showControls();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visible = entry.isIntersecting;
            if (entry.isIntersecting) {
              this.load();
              this.play();
            } else {
              this.video.pause();
            }
          });
        },
        // Start the fetch a little before it arrives, so the first frame is
        // ready rather than beginning to download on screen.
        { threshold: 0.25, rootMargin: '200px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      if (this.video.dataset.loaded) return;
      this.video.dataset.loaded = '1';
      this.video.src = this.video.dataset.src;
      // preload="none" means the play() below is a request, not a start: ask
      // again once there are frames, provided it is still on screen.
      this.video.addEventListener(
        'loadeddata',
        () => {
          if (this.video.paused && this.visible) this.play();
        },
        { once: true }
      );
    }

    play() {
      const attempt = this.video.play();
      if (!attempt || !attempt.catch) return;
      attempt.catch((error) => {
        // Scrolling away mid-request aborts, which the next intersection fixes.
        // Anything else is the browser refusing autoplay, and a frozen poster
        // with no way into it is worse than a control bar.
        if (error && error.name === 'AbortError') return;
        this.showControls();
      });
    }

    showControls() {
      this.video.controls = true;
      this.classList.add('pdp-steps__video--controls');
    }
  }

  customElements.define('pdp-steps-video', StepsVideo);
})();
